// =====================================================
// 📁 QuotationSummaryTotals.tsx
// =====================================================

import { useQuotation } from '../../../../../../hooks/sale/useQuotation';

import QuotationGlobalDiscountSection from '../../discount/QuotationGlobalDiscountSection';

import QuotationSummaryTotalRow from './QuotationSummaryTotalRow';

import { formatCurrency } from '../../../../../../utils/formatCurrency';

const QuotationSummaryTotals = () => {
  // =====================================================
  // 🔹 Hooks
  // =====================================================

  const {
    form,

    applyDiscount,
    removeDiscount,
  } = useQuotation();

  // =====================================================
  // 🔹 Totals
  // =====================================================

  const totals = [
    {
      key: 'itemsDiscountTotal',

      label: 'Descuentos Items',

      value: form?.itemsDiscountTotal || 0,
    },

    ...(Number(form?.globalDiscountAmount || 0) > 0
      ? [
          {
            key: 'globalDiscountAmount',

            label: 'Descuento Global',

            value: form?.globalDiscountAmount || 0,
          },
        ]
      : []),
  ];

  const total = Number(form?.total || 0);

  // =====================================================
  // 🎨 Render
  // =====================================================

  return (
    <div
      className="
      mt-5
    "
    >
      {/* ===================================================== */}
      {/* 🔹 Discount Action */}
      {/* ===================================================== */}

      <QuotationGlobalDiscountSection
        initialValue={form?.globalDiscountPercent || 0}
        initialTarget={form?.globalDiscountTarget || 'PRODUCTS'}
        onApply={(discount, target) => {
          if (!form?.id) {
            return;
          }

          applyDiscount(form.id, discount, false, target);
        }}
        onRemove={() => {
          if (!form?.id) {
            return;
          }

          removeDiscount(form.id);
        }}
      />

      {/* ===================================================== */}
      {/* 🔹 Detail Totals */}
      {/* ===================================================== */}

      <div className="mt-5 space-y-3">
        {totals.map((item) => (
          <QuotationSummaryTotalRow key={item.key} item={item} />
        ))}
      </div>

      {/* ===================================================== */}
      {/* 🔹 Final Total */}
      {/* ===================================================== */}

      <div
        className="
        mt-5

        flex
        items-center
        justify-between

        border-t
        border-stroke

        pt-4

        dark:border-strokedark
      "
      >
        <span
          className="
          text-lg
          font-semibold

          text-black

          dark:text-white
        "
        >
          Total cotización
        </span>

        <span
          className="
            text-3xl
            font-bold
            tracking-tight
            text-primary
          "
        >
          ${formatCurrency(total)}
        </span>
      </div>
    </div>
  );
};

export default QuotationSummaryTotals;
